import { render } from "./QuestaoOpcoesComponent.vue?vue&type=template&id=a15f9c92&scoped=true&ts=true"
import script from "./QuestaoOpcoesComponent.vue?vue&type=script&lang=ts"
export * from "./QuestaoOpcoesComponent.vue?vue&type=script&lang=ts"

import "./QuestaoOpcoesComponent.vue?vue&type=style&index=0&id=a15f9c92&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a15f9c92"]])

export default __exports__